// import logoo from "../assets/logo/imdady_logo.png";
import { BsPersonVcard, BsQrCode } from "react-icons/bs";
import { AiOutlineDashboard } from "react-icons/ai";
import { CiSettings } from "react-icons/ci";
import { IoHomeOutline } from "react-icons/io5";
import { FiTruck } from "react-icons/fi";
import { FaRegFile } from "react-icons/fa";
import { FaChartLine } from "react-icons/fa";
import { IoMdDesktop } from "react-icons/io";
import { FaRegWindowRestore } from "react-icons/fa6";
import { BsUniversalAccessCircle } from "react-icons/bs";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import { LiaComments } from "react-icons/lia";
import { IoPricetagsOutline } from "react-icons/io5";
import { FaRegTrashCan } from "react-icons/fa6";
import { PiUsersThreeLight } from "react-icons/pi";
import { LiaTasksSolid } from "react-icons/lia";
// import { GoDot } from "react-icons/go";
import { PiForkKnife } from "react-icons/pi";
// import SidenavItem from "./SidenavItem";
import { languageHelper } from "../../config/helperFunctions";
import SidenavDesktop from "./SidenavDesktop";
import SidenavMobile from "./SidenavMobile";

export default function SidenavNew({ logo }) {
  const Menus = [
    {
      title: "Home",
      label: languageHelper("home"),
      icon: <IoHomeOutline className="text-2xl block float-left" />,
      link: "home",
    },
    {
      title: "Dashboard",
      label: languageHelper("Dashboard"),
      icon: <AiOutlineDashboard className="text-2xl block float-left" />,
      link: "dashboard",
      // commingSoon: true,
    },
    {
      title: "Setting",
      label: languageHelper("Setting"),
      icon: <CiSettings className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "Setting",
          label: languageHelper("Setting"),
          link: "setting",
        },
        {
          title: "Language",
          label: languageHelper("language"),
          link: "language",
        },
      ],
    },
    {
      title: "Items",
      label: languageHelper("Items"),
      submenu: true,
      icon: <PiForkKnife className="text-2xl block float-left" />,
      submenuItems: [
        {
          title: "Main Categories",
          label: languageHelper("Main Categories"),
          link: "foodMenuCategories",
        },
        {
          title: "Sub Categories",
          label: languageHelper("Sub Categories"),
          link: "foodMenuSubCategories",
        },
        {
          title: "Items",
          label: languageHelper("Items"),
          link: "foodMenus",
        },
        {
          title: "Add Ons",
          label: languageHelper("Add Ons"),
          link: "modifiers",
        },
        {
          title: "Deals",
          label: languageHelper("Deals"),
          link: "deals",
        },
        {
          title: "VATs",
          label: languageHelper("VATs"),
          link: "VATs",
        },
        {
          title: "Ingredient Categories",
          label: languageHelper("Ingredient Categories"),
          link: "ingredientCategory",
        },
        {
          title: "Ingredients",
          label: languageHelper("Ingredients"),
          link: "ingredients",
        },
        {
          title: "Ingredient Units",
          label: languageHelper("Ingredient Units"),
          link: "units",
        },
      ],
    },
    {
      title: "Management",
      label: languageHelper("Management"),
      icon: <BsPersonVcard className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "Subscriptions Management",
          label: languageHelper("Subscriptions Management"),
          link: "subscription-managment",
          // commingSoon: true,
        },
        {
          title: "Delivery Companies",
          label: languageHelper("Delivery Companies"),
          link: "delivery-companies",
          // commingSoon: true,
        },
        {
          title: "Printer",
          label: languageHelper("Printer"),
          link: "printer",
        },
        {
          title: "Tables",
          label: languageHelper("Tables"),
          link: "tables",
        },
        {
          title: "Return",
          label: languageHelper("Return"),
          link: "return",
        },
        {
          title: "Deposit",
          label: languageHelper("Deposit"),
          link: "deposite",
          // commingSoon: true,
        },
        {
          title: "Copy Items",
          label: languageHelper("Copy Items"),
          link: "copy-items",
          commingSoon: true,
        },
        {
          title: "Clean database",
          label: languageHelper("Clean Database"),
          link: "cleanDatabase",
          commingSoon: true,
        },
      ],
    },
    {
      title: "Delivery",
      label: languageHelper("Delivery"),
      icon: <FiTruck className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "Rider Order",
          label: languageHelper("Rider Order"),
          link: "listorder",
          // commingSoon: true,
        },
      ],
    },
    {
      title: "Outlet",
      label: languageHelper("Outlet"),
      icon: <CiSettings className="text-2xl block float-left" />,
      link: "outlet",
      // commingSoon: true,
    },
    {
      title: "Reporting",
      label: languageHelper("Reporting"),
      icon: <FaRegFile className="text-2xl block float-left" />,
      link: "reporting",
      // commingSoon: true,
    },
    {
      title: "All Sales",
      label: languageHelper("All Sales"),
      icon: <FaChartLine className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "POS Sales",
          label: languageHelper("POS Sales"),
          link: "allsales",
        },
        {
          title: "Online Sales",
          label: languageHelper("Online Sales"),
          link: "weborder",
        },
      ],
    },
    {
      title: "Screens",
      label: languageHelper("Screens"),
      icon: <IoMdDesktop className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "POS",
          label: languageHelper("pos"),
          link: "/POS/main",
        },
        {
          title: "Kitchen",
          label: languageHelper("Kitchen"),
          link: "kitchen",
          // commingSoon: true,
        },
        // { title: "Bar", link: "barPanel" },
        // {
        //   title: "Waiter",
        //   label: languageHelper("Waiter"),
        //   link: "waiter",
        //   commingSoon: true,
        // },
      ],
    },
    {
      title: "E-Commerce",
      label: languageHelper("E-Commerce"),
      icon: <FaRegWindowRestore className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "Sms Module",
          label: languageHelper("Sms Module"),
          link: "smsMobile",
          commingSoon: true,
        },
        {
          title: "Payment Gateway",
          label: languageHelper("Payment Gateway"),
          link: "paymentGateway",
          commingSoon: true,
        },
        {
          title: "Banners",
          label: languageHelper("Banners"),
          link: "bannersetting",
        },
        {
          title: "Top Banner",
          label: languageHelper("Top Banner"),
          link: "topbanner",
        },
        {
          title: "Qrcode",
          label: languageHelper("Qrcode"),
          link: "qrCode",
        },
        {
          title: "Order Type",
          label: languageHelper("Order Type"),
          link: "ordertype",
        },
        {
          title: "Web Setting",
          label: languageHelper("Web Setting"),
          link: "webSetting",
          // commingSoon: true,
        },
        {
          title: "Mail Config",
          label: languageHelper("Mail Config"),
          link: "mailConfig",
          commingSoon: true,
        },
        {
          title: "Social Media",
          label: languageHelper("Social Media"),
          link: "socialmedia",
          // commingSoon: true,
        },
      ],
    },
    {
      title: "Accounting",
      label: languageHelper("Accounting"),
      icon: <BsUniversalAccessCircle className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "Setup",
          label: languageHelper("Setup"),
          link: "setup",
          // commingSoon: true,
        },
      ],
    },
    {
      title: "Zatca",
      label: languageHelper("Zatca"),
      icon: <BsQrCode className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "CSR Setup",
          label: languageHelper("CSR Setup"),
          link: "zatca/csrSetup",
        },
        {
          title: "Get Key",
          label: languageHelper("Get Key"),
          link: "zatca/getKey",
        },
        {
          title: "Renew Production Key",
          label: languageHelper("Renew Production Key"),
          link: "zatca/renewProductionKey",
        },
        {
          title: "Test Invoice",
          label: languageHelper("Test Invoice"),
          link: "zatca/testInvoice",
        },
        {
          title: "Invoice Logs",
          label: languageHelper("Invoice Logs"),
          link: "zatca/invoiceLogs",
        },
      ],
    },
    {
      title: "Promotion",
      label: languageHelper("Promotion"),
      icon: <FaRegMoneyBillAlt className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "Coupon",
          label: languageHelper("Coupon"),
          link: "coupon",
        },
        {
          title: "Credit Card",
          label: languageHelper("Credit Card"),
          link: "creditCard",
        },
        {
          title: "Subscriptions",
          label: languageHelper("Subscriptions"),
          link: "subscription",
          // commingSoon: true,
        },
        {
          title: "Loyalty",
          label: languageHelper("Loyalty"),
          link: "loyalty",
        },
        {
          title: "Product discount",
          label: languageHelper("Product Discount"),
          link: "productdiscount",
        },
        {
          title: "Category discount",
          label: languageHelper("Category Discount"),
          link: "categorydiscount",
        },
        {
          title: "Category Schedule",
          label: languageHelper("Category Schedule"),
          link: "categorySchedule",
        },
      ],
    },
    {
      title: "Customer Feedback",
      label: languageHelper("Customer Feedback"),
      icon: <HiOutlinePencilSquare className="text-2xl block float-left" />,
      link: "customer-feedback",
      // commingSoon: true,
    },
    {
      title: "Feedback",
      label: languageHelper("Feedback"),
      icon: <LiaComments className="text-2xl block float-left" />,
      link: "feedback",
      // commingSoon: true,
    },
    {
      title: "Purchase",
      label: languageHelper("Purchase"),
      icon: <IoPricetagsOutline className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "Add Purchase",
          label: languageHelper("Add Purchase"),
          link: "purchase",
        },
        {
          title: "Inventory",
          label: languageHelper("Inventory"),
          link: "inventory",
          // commingSoon: true,
        },
        {
          title: "Inventory Adjustments",
          label: languageHelper("Inventory Adjustments"),
          link: "inventoryAdjustment",
          // commingSoon: true,
        },
        {
          title: "Expense Category",
          label: languageHelper("Expense Category"),
          link: "expensescategory",
        },
        {
          title: "Expense",
          label: languageHelper("Expense"),
          link: "expenses",
        },
      ],
    },
    {
      title: "Waste",
      label: languageHelper("Waste"),
      icon: <FaRegTrashCan className="text-2xl block float-left" />,
      link: "waste",
      // commingSoon: true,
    },
    {
      title: "User Section",
      label: languageHelper("User Section"),
      icon: <PiUsersThreeLight className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "Companies",
          label: languageHelper("Companies"),
          link: "companies",
          commingSoon: true,
        },
        {
          title: "Suppliers",
          label: languageHelper("Suppliers"),
          link: "suppliers",
        },
        {
          title: "Vendor",
          label: languageHelper("Vendor"),
          link: "vendor",
        },
        {
          title: "Customers",
          label: languageHelper("Customers"),
          link: "customer",
        },
        // { title: "Supplier Due Payment", link: "supplierPayment" },
        // { title: "Customer Due Receive", link: "customerReceive" },
        // { title: "Attendance", link: "attendance" },
      ],
    },
    {
      title: "Role Management",
      label: languageHelper("Role Management"),
      icon: <LiaTasksSolid className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "General Settings",
          label: languageHelper("General Settings"),
          link: "generalSetting",
          commingSoon: true,
        },
        {
          title: "User Management",
          label: languageHelper("User Management"),
          link: "manageUser",
        },
      ],
    },
  ];

  return (
    <>
      <div className="lg:hidden">
        <SidenavMobile Menus={Menus} logo={logo} />
      </div>
      <div className="hidden lg:block">
        <SidenavDesktop Menus={Menus} logo={logo} />
      </div>
    </>
  );
}
